import React, { useMemo } from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { FormBaseElement } from './form-base-element'
import {
  FormFieldInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { contactFieldLocoKeys } from 'src/editor/shared/utils/get-contact-field-title'

interface FormFieldProps {
  formEntity: FormInterface
  field: FormFieldInterface
}

// NOTE: this is a draft
export const FormField = ({ formEntity, field }: FormFieldProps) => {
  const entity = useMemo(
    () => ({
      ...field,
      // TODO: add common fields props
    }),
    [field],
  )

  return (
    <FormBaseElement
      title={contactFieldLocoKeys[field.slug]}
      formEntity={formEntity}
      element={field}
    >
      <BaseEditorField entity={entity} />
    </FormBaseElement>
  )
}
